module.exports = __webpack_public_path__ + "static/media/RKBrowser6w721@1x.96d9c38e.webp";